import gsap from "gsap";

const closeModal = () => {
  gsap.to(".overlay__modal", {
    opacity: 1,
    transform: "translateX(100%)",
    duration: 1,
    ease: "power3.inOut",
  });
};

export default closeModal;
